<template>
  <modal :show="open">
    <template #overlay>
      <div v-show="open" class="fixed inset-0 transform transition-all">
        <div class="absolute inset-0 bg-black/25 backdrop-blur-[5px]"></div>
      </div>
    </template>
    <div class="">
      <div class="pointer-events-auto mx-auto rounded-xl p-6 shadow-lg">
        <h2 class="text-lg font-semibold leading-6 text-gray-900 mb-2">{{ __('Cookie Consent') }}</h2>
        <p class="text-sm leading-6 text-gray-900">
          {{ __('This website uses strictly necessary cookies for essential functionality and security purposes. No additional cookies are set without your explicit consent. By continuing to use the website, you consent to the use of these necessary cookies. For more information, please refer to our privacy policy.') }}
        </p>
        <div class="mt-4 flex items-center gap-x-5">
          <button @click="setCookie" v-motion-pop :delay="15" type="button" class="rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900">{{ __('Accept') }}</button>
          <a target="_blank" :href="route('policy.show')" class="text-sm font-semibold leading-6 text-gray-900">{{ __('Privacy-Policy') }}</a>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/Jetstream/Modal'

export default {
  components: {
    Modal,
  },
  data() {
    return {
      open: false,
    }
  },
  mounted() {
    if (!this.hasCookie()) {
      this.$nextTick(() => {
        this.open = true;
      });
    }
  },
  methods: {
    setCookie() {
      const cookieName = 'livck_cookie_consent';
      const cookieValue = 'true';

      document.cookie = `${cookieName}=${cookieValue}; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/`;
      this.open = false;
    },
    hasCookie() {
      return this.getCookie('livck_cookie_consent') === 'true';
    },
    getCookie(name) {
      const cookies = document.cookie.split('; ');

      for (let i = 0; i < cookies.length; i++) {
        const [cookieName, cookieValue] = cookies[i].split('=');
        if (cookieName === name) {
          return cookieValue;
        }
      }

      return null;
    },
  },
};
</script>